<template>
  <v-container
    class="pa-0"
  >
    <v-row
      no-gutters
    >
      <v-col
        cols="12"
        class="pa-0"
      >
      <v-expansion-panels
      :multiple="true"
      v-model="isExpand"
      class="elevation-0 pa-0"
      flat
    >
      <v-expansion-panel
        class="wrld_background pa-0"
      >
        <v-expansion-panel-header
        class="pa-1"
        color="#FAFAFA"
        >
          <span
          class="filter--title"
          >{{ rangeFilter.title }}
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0" color="#FAFAFA">
          <v-card
            flat
            color="transparent"
            class="pb-0"
          >
            <v-card-text>
              <v-range-slider
                v-model="ranges"
                :min="min"
                :max="max"
                thumb-label="always"
                :thumb-size="35"
                @end="handleRangeInput"
              >
              <template v-slot:thumb-label="{ value }">
                <span
                  class="text-truncate"
                >
                  {{ handleRangeThumbValue(value) }}
                </span>
              </template>
              </v-range-slider>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'WrldShipmentsGroupByDayRangeFilters',
    props: {
      rangeFilter: {type: Object, deafult: () => null},
      wrld: { type: Object, default: () => null }
    },
    data() {
      return {
        isExpand: [],
        min: 0,
        max: 0,
        ranges: [0, 0],
      }
    },
    methods: {
      ...mapActions({
        setRangeFilterFromTo: 'rangesFilters/setRangeFilterFromTo',
      }),
      handleRangeInput (values) {
        switch (this.rangeFilter.attribute) {
          case 'Weight':
            this.setRangeFilterFromTo({ attribute: this.rangeFilter.attribute, from: values[0], to: values[1] })
            break;
          default:
            this.setRangeFilterFromTo({ attribute: this.rangeFilter.attribute, from: values[0], to: values[1] })
            break;
        }
      },
      handleRangeThumbValue(value) {
        switch (this.rangeFilter.attribute) {
          case 'Weight':
            return `${this.$options.filters.roundValueWeightToNumber(value, 0)}`
          case 'Volume':
            return `${this.$options.filters.roundValueToNumber(value, 1)}`
          default:
            return value
        }
      }
    },
    computed: {
      ...mapGetters({
        getRangeLimits: 'rangesFilters/getRangeLimits',
        getRangeValues: 'rangesFilters/getRangeValues'
      }),
      computeRangeFilterCurrentValues () {
        return this.getRangeValues(this.rangeFilter.attribute)
      },
      computeRangeFilterLimitValues() {
        return this.getRangeLimits(this.rangeFilter.attribute)
      },
    },
    watch: {
      computeRangeFilterLimitValues: {
        deep: true,
        immediate: true,
        handler (val, oldVal) {
          if (val != null) {
            this.min = val.from,
            this.max = val.to
          }
        }
      },
      computeRangeFilterCurrentValues: {
        deep: true,
        immediate: true,
        handler (val, oldVal) {
          if (val != null) {
            this.ranges = []
            if (val.from != null) {
              this.ranges.push(val.from)
            } else {
              this.ranges.push(this.computeRangeFilterLimitValues.from)
            }
            if (val.to != null) {
              this.ranges.push(val.to)
            } else {
              this.ranges.push(this.computeRangeFilterLimitValues.to)
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.filter--title {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: var(--v-wrld_title) !important;
}
</style>
